import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Button, Divider, Form, Grid, Header, Icon, Popup, Segment,Statistic,Card, Message} from "semantic-ui-react";
import ClerkDashBoard from './clerk_dashboard';
import ProvisionalOfferListing from './provisional_offer_listing';
import LastInspectionsListing from './last_inspections_booked';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import Loader from "../universal/loader";
import moment from 'moment';
import DashboardStatistics from "../../containers/dashboard_container";
import FilterAttributes from "../../containers/filter_container";
import {BASE_URL, CUSTOM_REPORT} from "../../constants/app_routes";
import { CLERK_API_URL } from '../../constants/api_routes';
import { handleFileDownload } from "../../utils/download_file";
import DownloadingIntent from "../universal/toast";
import { getChasingData,getPVChasingData } from '../../data/dashboard_api';
import PushNotificationWindow from './push_notification_window';
import {isUserSubscribed} from "../../utils/push_notifications"
import WeeklyAvailability from '../user/clerk/weekly_availability';
import { getCurrentUserProfile,updateProfileById } from '../../data/user_api';
import AvailLeave from "../user/clerk/avail_leave";


class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userRole: undefined,
            fromDate: moment().add('-1',"month").startOf('month').format("DD-MM-YYYY"),
            toDate: moment().add('2',"month").endOf('month').format("DD-MM-YYYY"),
            dateFiltered: false,
            dashboardData: undefined,
            dateError: false,
            showClerkDashboard:false,
            UrlsToOpen:[],
            isMobile: window.innerWidth < 768,
            isSubscribed:false,
            isLoadingAvailability:false,
            showLeave: false
        }
    }

   componentDidMount() {
  // Load user safely
  const userRaw = localStorage.getItem("user");

  if (userRaw) {
    const user = JSON.parse(userRaw);
    this.setState({
      userRole: user.role,
      userId: user.user_id,
      profile_id:user.profile_id
    });
  }
    isUserSubscribed().then(isSubscribed => {
      this.setState({ isSubscribed });
    });

  // Load dashboard data
  this.props.getDashboardData(this.state.fromDate, this.state.toDate);
}


    handleFilterSelection() {
        this.setState({dateFiltered: true});
        if(this.state.fromDate && this.state.toDate){
            this.props.getDashboardData(this.state.fromDate, this.state.toDate);
            this.props.getClerkDashboardData(this.state.fromDate, this.state.toDate);
        }
    }

    exportInspections = async (due) => {
        this.setState({isDownloading:true,showDownload:true});
        let URL = BASE_URL + "/export/inspections?due=" + due;
        let fileName = " Inspections List " + moment().format("DD-MM-YYYY") + ".xlsx";
        if (due === "due") {fileName = "Due" + fileName} else {fileName = "Overdue" + fileName}
        await handleFileDownload(URL,fileName,'application/xlsx');
        this.setState({isDownloading:false});
    };
    
delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

chaseReports = async (o365 = false) => {
    this.setState({ isWaiting: true });
    let response = await getChasingData();
    let groupedObject = {};
    let UrlsToOpen = []
    
    response.inspections.forEach((inspection) => {
        if (inspection.clerk) {
            let key = inspection.clerk.trim();
            if (!groupedObject[key]) {
                groupedObject[key] = { inspections: [], email: inspection.email };
            }
            groupedObject[key].inspections.push(inspection);
        }
    });

    for (const clk of Object.keys(groupedObject)) {
            let emailString = "";

            groupedObject[clk].inspections.forEach((insp) => {
            const dateStr = moment(insp.inspection_time.inspection_date, "YYYY-MM-DD").format("DD-MM-YYYY");
            emailString += `${dateStr} - ${insp.inspection_type} - ${insp.property.address} - ${insp.company_name}\n\n`;
            });

            const subject = `${groupedObject[clk].inspections.length} Due Reports - ${clk}`;
            const body = `Hi ${clk.split(" ")[0]}\n\nPlease note the below jobs due by 2pm today – please let us know ETA if you envisage any delay.\n\n${emailString}\nThanks`;

            const encodedEmail = encodeURIComponent(groupedObject[clk].email);
            const encodedSubject = encodeURIComponent(subject);
            const encodedBody = encodeURIComponent(body);

            let url = []
            url["name"] = clk
            url["o365"] = `https://outlook.office.com/mail/deeplink/compose?to=${encodedEmail}&subject=${encodedSubject}&body=${encodedBody}`;
            url["desktop"] = `mailto:${encodedEmail}?subject=${encodedSubject}&body=${encodedBody}`;

                // window.open(url);
                UrlsToOpen.push(url);

        // Wait 1 second between emails to avoid browser suppressing the calls
        // await this.delay(1000);
    }

    this.setState({ isWaiting: false,UrlsToOpen:UrlsToOpen });
};     

openAvailability = async () =>{
  let  profileId = JSON.parse(localStorage.getItem('user'))['profile_id']
    this.setState({ isLoadingAvailability: true})
          const {profileData} = await getCurrentUserProfile(CLERK_API_URL, profileId);
          this.setState({profileData: profileData['clerk_profile'],isLoadingAvailability:false,updatingAvailability:true});

}
openEmailWindows = (o365 = false) =>{

    if (o365 == true) {

        this.state.UrlsToOpen.forEach((url) => {
            window.open(url["o365"]);
        });
    } else {
          this.state.UrlsToOpen.forEach((url) => {
            window.open(url["desktop"]);
        });
    }
}

chasePVReports = async (o365 = false) => {
    this.setState({ isWaiting: true });
    let response = await getPVChasingData();
    let groupedObject = {};

    response.forEach((pv) => {
        if (pv.clerk) {
            let key = pv.clerk.trim();
            if (!groupedObject[key]) {
                groupedObject[key] = { visits: [], email: pv.email };
            }
            groupedObject[key].visits.push(pv);
        }
    });

    for (const clk of Object.keys(groupedObject)) {
        let emailString = "";
        groupedObject[clk].visits.forEach((visit) => {
            emailString += ` ${moment(visit.visit_date, "YYYY-MM-DD").format("DD-MM-YYYY")} - PV - ${visit.address} - ${visit.company} %0D%0A%0D%0A`;
        });

        const subject = `${groupedObject[clk].visits.length} Due PV Reports - ${clk}`;
        const body = `Hi ${clk.split(" ")[0]} %0D%0A%0D%0APlease note the below jobs due by 2pm today- please let us know ETA if you envisage any delay. %0D%0A%0D%0A${emailString}%0D%0A%0D%0AThanks`;

        if (o365) {
            window.open(`https://outlook.office.com/mail/deeplink/compose?to=${groupedObject[clk].email}&subject=${subject}&body=${body}`);
        } else {
            window.open(`mailto:${groupedObject[clk].email}?subject=${subject}&body=${body}`);
        }

        await this.delay(1000); // Pause between opens
    }

    this.setState({ isWaiting: false });
};

renderStatObject = (data)=>{
    return <Grid stackable columns="equal">
                {!this.state.isMobile &&       <Grid.Row>
                    <Header size="large" content={"PROPERTY DASHBOARD (" + moment(this.state.fromDate, "DD-MM-YYYY").format("LL") + " to " + moment(this.state.toDate, "DD-MM-YYYY").format("LL") + ")"}  textAlign="left"/>
                </Grid.Row>}
                {data && !this.state.isMobile && <React.Fragment>
                    <Header size="large" content="Inventories" textAlign="left" />
                <Grid.Row>
                    <Grid.Column width={4}>
                    <Statistic.Group size="small" color="grey" widths={2}>
                        <Statistic className="icon-button" onClick={()=>{this.props.setFilter("completed",this.state.fromDate,this.state.toDate);this.props.history.push('/inspection')}}>
                            <Statistic.Value className="stat-card">{data['completed']}</Statistic.Value>
                            <Statistic.Label>Completed</Statistic.Label>
                        </Statistic>
                        <Statistic>
                            <Statistic.Value className="stat-card stat-card-margin">{data['total_number_of_inspections']}</Statistic.Value>
                            <Statistic.Label>Total Requests</Statistic.Label>
                        </Statistic>
                    </Statistic.Group>
                    </Grid.Column>
                    <Grid.Column width={12}>
                        <Statistic.Group size="small" color="grey" widths={6}>
                           {this.props.userRole != "clerk" && <Statistic className="icon-button" onClick={()=>{this.props.setFilter("pending",this.state.fromDate,this.state.toDate);this.props.history.push('/inspection')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['pending']}</Statistic.Value>
                                <Statistic.Label>Pending</Statistic.Label>
                            </Statistic>}
                            <Statistic className="icon-button" onClick={()=>{this.props.setFilter("scheduled",this.state.fromDate,this.state.toDate);this.props.history.push('/inspection')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['scheduled']}</Statistic.Value>
                                <Statistic.Label>Scheduled</Statistic.Label>
                            </Statistic>
                            <Statistic className="icon-button" onClick={()=>{this.props.setFilter("confirmed",this.state.fromDate,this.state.toDate);this.props.history.push('/inspection')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['confirmed']}</Statistic.Value>
                                <Statistic.Label>Confirmed</Statistic.Label>
                            </Statistic>
                            <Statistic className="icon-button" onClick={()=>{this.props.setFilter("processing",this.state.fromDate,this.state.toDate);this.props.history.push('/inspection')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['processing']}</Statistic.Value>
                                <Statistic.Label>Processing</Statistic.Label>
                            </Statistic>
                            <Statistic className="icon-button" onClick={()=>{this.props.setFilter("submitted",this.state.fromDate,this.state.toDate);this.props.history.push('/inspection')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['submitted']}</Statistic.Value>
                                <Statistic.Label>Submitted</Statistic.Label>
                            </Statistic>
                            <Statistic className="icon-button" onClick={()=>{this.props.setFilter("abort",this.state.fromDate,this.state.toDate);this.props.history.push('/inspection')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['aborted']}</Statistic.Value>
                                <Statistic.Label>Aborted</Statistic.Label>
                            </Statistic>
                        </Statistic.Group>
                    </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                    <Grid.Column width={16}>
                    <Header size="large" content="Property Visits" textAlign="left">Property Visits 
                         </Header>
                        <Statistic.Group size="small" color="grey" widths={8}>
                            <Statistic className="icon-button" onClick={()=>{this.props.setFilter("pending",this.state.fromDate,this.state.toDate);this.props.history.push('/property_visit')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['pv_pending']}</Statistic.Value>
                                <Statistic.Label>Pending</Statistic.Label>
                            </Statistic>
                            <Statistic className="icon-button" onClick={()=>{this.props.setFilter("scheduled",this.state.fromDate,this.state.toDate);this.props.history.push('/property_visit')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['pv_scheduled']}</Statistic.Value>
                                <Statistic.Label>Scheduled</Statistic.Label>
                            </Statistic>
                            <Statistic className="icon-button" onClick={()=>{this.props.setFilter("confirmed",this.state.fromDate,this.state.toDate);this.props.history.push('/property_visit')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['pv_confirmed']}</Statistic.Value>
                                <Statistic.Label>Confirmed</Statistic.Label>
                            </Statistic>
                            <Statistic className="icon-button" onClick={()=>{this.props.setFilter("submitted",this.state.fromDate,this.state.toDate);this.props.history.push('/property_visit')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['pv_submitted']}</Statistic.Value>
                                <Statistic.Label>Submitted</Statistic.Label>
                            </Statistic>
                            <Statistic className="icon-button" onClick={()=>{this.props.setFilter("completed",this.state.fromDate,this.state.toDate);this.props.history.push('/property_visit')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['pv_completed']}</Statistic.Value>
                                <Statistic.Label>Completed</Statistic.Label>
                            </Statistic>
                            <Statistic className="icon-button" onClick={()=>{this.props.setFilter("aborted",this.state.fromDate,this.state.toDate);this.props.history.push('/property_visit')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['pv_aborted']}</Statistic.Value>
                                <Statistic.Label>Aborted</Statistic.Label>
                            </Statistic>
                            {this.props.userRole != "agent" && <React.Fragment>
                                <Statistic className="icon-button" onClick={()=>{this.props.setFilter("due",this.state.fromDate,this.state.toDate);this.props.history.push('/property_visit')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['pv_duetoday']}</Statistic.Value>
                                <Statistic.Label>Due Today</Statistic.Label>
                            </Statistic>
                            <Statistic className="icon-button"  onClick={()=>{this.props.setFilter("due",this.state.fromDate,this.state.toDate);this.props.history.push('/property_visit')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['pv_overdue']}</Statistic.Value>
                                <Statistic.Label>Overdue</Statistic.Label>
                            </Statistic>
                                </React.Fragment>}
                         {this.props.userRole == "agent" && <Statistic className="icon-button" onClick={()=>{this.props.setFilter("not_downloaded",this.state.fromDate,this.state.toDate);this.props.history.push('/property_visit')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['pv_not_downloaded']}</Statistic.Value>
                                <Statistic.Label>Not Downloaded</Statistic.Label>
                            </Statistic>}
                        </Statistic.Group>
                    </Grid.Column>
                    </Grid.Row>

                {!(this.props.userRole === "agent") && <Grid.Row>
                        <Grid.Column width={4}>
                        <Header size="large" textAlign="left" >Due Reports
                            </Header>
                            <Statistic.Group size="small" color="grey" widths={2}>
                            <Statistic className="icon-button">
                                <Statistic.Value className="stat-card stat-card-margin" onClick={() => { {this.props.setFilter("due",this.state.fromDate,this.state.toDate);this.props.history.push('/inspection')} }}>{data['overdue'] ? data['overdue'] : "N/A"} </Statistic.Value>
                                <Statistic.Label>Overdue</Statistic.Label>
                                <Popup content="Click to export list of overdue inspections" trigger={
                                    <Button content="Export" onClick={() => { this.exportInspections("overdue") }} style={{ width: "75%", margin: "auto" }} />}>
                                    </Popup>
                            </Statistic>
                            <Statistic className="icon-button" >
                                <Statistic.Value  className="stat-card stat-card-margin" onClick={() => { {this.props.setFilter("due",this.state.fromDate,this.state.toDate);this.props.history.push('/inspection')} }}>{data['duetoday'] ? data['duetoday'] : "N/A"}</Statistic.Value>
                                <Statistic.Label>Due Today</Statistic.Label>
                                <Popup content="Click to export list of inspections due today" trigger={
                                    <Button content="Export" onClick={() => { this.exportInspections("due") }} style={{ width: "75%", margin: "auto" }} />} >
                                </Popup>
                                </Statistic>
                            </Statistic.Group>
                        </Grid.Column>
                        <Grid.Column widths={8}>
                        <Header size="large">Customer Service</Header>
                            <Statistic.Group size="small" color="grey" widths={5}>
                            <Statistic className="icon-button" onClick={()=>{this.props.setFilter("pending",this.state.fromDate,this.state.toDate);this.props.history.push('/customer_service')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['cs_pending']}</Statistic.Value>
                                <Statistic.Label>Pending</Statistic.Label>
                                </Statistic>
                                <Statistic className="icon-button" onClick={()=>{this.props.setFilter("awaiting_clerk_reply",this.state.fromDate,this.state.toDate);this.props.history.push('/customer_service')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['cs_awaiting_clerk_reply']}</Statistic.Value>
                                <Statistic.Label>Awaiting Clerk Reply</Statistic.Label>
                                </Statistic>
                                <Statistic className="icon-button" onClick={()=>{this.props.setFilter("awaiting_clerk_reply",this.state.fromDate,this.state.toDate);this.props.history.push('/customer_service')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['cs_awaiting_clerk_reply_over_24h'].length}</Statistic.Value>
                                <Statistic.Label>Awating Reply Over 24h</Statistic.Label>
                                </Statistic>
                                <Statistic className="icon-button" onClick={()=>{this.props.setFilter("awaiting_admin_review",this.state.fromDate,this.state.toDate);this.props.history.push('/customer_service')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['cs_awaiting_admin_review']}</Statistic.Value>
                                <Statistic.Label>Awaiting Admin Review</Statistic.Label>
                                </Statistic>
                                <Statistic className="icon-button" onClick={()=>{this.props.setFilter("closed",this.state.fromDate,this.state.toDate);this.props.history.push('/customer_service')}}>
                                <Statistic.Value className="stat-card stat-card-margin">{data['cs_closed']}</Statistic.Value>
                                <Statistic.Label>Closed</Statistic.Label>
                            </Statistic>
                            </Statistic.Group>
                        </Grid.Column>
                </Grid.Row>}
                </React.Fragment> }
                {data && this.state.isMobile && <React.Fragment><Grid.Row><Grid.Column width={16}>
                    <Header align="center" as="h1">Inspection Statistics</Header><br/>
                    <Card.Group
                    className="fullwidth-mobile-cards"
                    itemsPerRow={2}
                    stackable
                    doubling
                    centered
                    >
                        {this.props.userRole != "agent" && <Card color="red"
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: 'auto' });
                            this.props.setFilter("scheduled", this.state.fromDate, this.state.toDate);
                            this.props.history.push('/inspection');
                        }}
                        className="stat-card icon-button"
                        >
                        <Card.Content textAlign="center">
                            <Card.Header>{data["scheduled"]}</Card.Header>
                            <Card.Meta>Scheduled</Card.Meta>
                            <Card.Description style={{color:"red"}}><Icon name="exclamation" color="red"/><strong>Please check these inspections and confirm</strong><Icon name="exclamation" color="red"/></Card.Description>
                        </Card.Content>
                        </Card>}
                    <Card
                        onClick={() => {
                        this.props.setFilter("completed", this.state.fromDate, this.state.toDate);
                        this.props.history.push('/inspection');
                        }}
                        color="green"
                    >
                        <Card.Content textAlign="center">
                        <Card.Header>{data['completed']}</Card.Header>
                        <Card.Meta>Completed</Card.Meta>
                        </Card.Content>
                    </Card>

                    <Card color="blue">
                        <Card.Content textAlign="center">
                        <Card.Header>{data['total_number_of_inspections']}</Card.Header>
                        <Card.Meta>Total Requests</Card.Meta>
                        </Card.Content>
                    </Card>

                    {this.props.userRole !== "clerk" && (
                        <Card
                        onClick={() => {
                            this.props.setFilter("pending", this.state.fromDate, this.state.toDate);
                            this.props.history.push('/inspection');
                        }}
                        color="orange"
                        >
                        <Card.Content textAlign="center">
                            <Card.Header>{data['pending']}</Card.Header>
                            <Card.Meta>Pending</Card.Meta>
                        </Card.Content>
                        </Card>
                    )}

                    {[
                        ['scheduled', 'Scheduled'],
                        ['confirmed', 'Confirmed'],
                        ['processing', 'Processing'],
                        ['submitted', 'Submitted'],
                        ['aborted', 'Aborted'],
                    ].map(([key, label]) => (
                        <Card
                        key={key}
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: 'auto' });
                            this.props.setFilter(key, this.state.fromDate, this.state.toDate);
                            this.props.history.push('/inspection');
                        }}
                        className="stat-card icon-button"
                        >
                        <Card.Content textAlign="center">
                            <Card.Header>{data[key]}</Card.Header>
                            <Card.Meta>{label}</Card.Meta>
                        </Card.Content>
                        </Card>
                    ))}
                    </Card.Group></Grid.Column></Grid.Row>
                    <Grid.Row><Grid.Column width={16}>
                          <Header align="center" as="h1">Customer Service Statistics</Header><br/>
                         <Card.Group
                            className="fullwidth-mobile-cards"
                            itemsPerRow={2}
                            stackable
                            doubling
                            centered
                            >
                            {[
                                ['pending', 'Pending', 'orange'],
                                ['awaiting_clerk_reply', 'Awaiting Clerk Reply', 'yellow'],
                                ['awaiting_clerk_reply', 'Awaiting Reply Over 24h', 'red', d => d['cs_awaiting_clerk_reply_over_24h'].length],
                                ['awaiting_admin_review', 'Awaiting Admin Review', 'blue'],
                                ['closed', 'Closed', 'green'],
                                ].map(([key, label, color, valueFn]) => (
                                <Card
                                key={key + label}
                                onClick={() => {
                                    window.scrollTo({ top: 0, behavior: 'auto' });
                                    this.props.setFilter(key, this.state.fromDate, this.state.toDate);
                                    this.props.history.push('/customer_service');
                                }}
                                className="stat-card icon-button"
                                color={color}
                                >
                                <Card.Content textAlign="center">
                                    <Card.Header>{valueFn ? valueFn(data) : data[`cs_${key}`]}</Card.Header>
                                    <Card.Meta>{label}</Card.Meta>
                                </Card.Content>
                                </Card>
                            ))}
                            </Card.Group>
                        </Grid.Column></Grid.Row>

                                            <Grid.Row><Grid.Column width={16}>
                          <Header align="center" as="h1">Property Visit Statistics</Header><br/>
                          <Card.Group
                            className="fullwidth-mobile-cards"
                            itemsPerRow={2}
                            stackable
                            doubling
                            centered
                            >
                            {/* Always visible cards */}
                            {[
                                ['pending', 'Pending', 'orange'],
                                ['scheduled', 'Scheduled', 'yellow'],
                                ['confirmed', 'Confirmed', 'blue'],
                                ['submitted', 'Submitted', 'teal'],
                                ['completed', 'Completed', 'green'],
                                ['aborted', 'Aborted', 'red'],
                            ].map(([key, label, color]) => (
                                <Card
                                key={key}
                                onClick={() => {
                                    window.scrollTo({ top: 0, behavior: 'auto' });
                                    this.props.setFilter(key, this.state.fromDate, this.state.toDate);
                                    this.props.history.push('/property_visit');
                                }}
                                className="stat-card icon-button"
                                color={color}
                                >
                                <Card.Content textAlign="center">
                                    <Card.Header>{data[`pv_${key}`]}</Card.Header>
                                    <Card.Meta>{label}</Card.Meta>
                                </Card.Content>
                                </Card>
                            ))}

                            {/* Conditional cards based on user role */}
                            {this.props.userRole !== "agent" ? (
                                <React.Fragment>
                                <Card className="stat-card icon-button" color="violet">
                                    <Card.Content textAlign="center">
                                    <Card.Header>{data['pv_duetoday']}</Card.Header>
                                    <Card.Meta>Due Today</Card.Meta>
                                    </Card.Content>
                                </Card>

                                <Card className="stat-card icon-button" color="grey">
                                    <Card.Content textAlign="center">
                                    <Card.Header>{data['pv_overdue']}</Card.Header>
                                    <Card.Meta>Overdue</Card.Meta>
                                    </Card.Content>
                                </Card>
                                </React.Fragment>
                            ) : (
                                <Card
                                className="stat-card icon-button"
                                color="purple"
                                onClick={() => {
                                    this.props.setFilter("not_downloaded", this.state.fromDate, this.state.toDate);
                                    this.props.history.push('/property_visit');
                                }}
                                >
                                <Card.Content textAlign="center">
                                    <Card.Header>{data['pv_not_downloaded']}</Card.Header>
                                    <Card.Meta>Not Downloaded</Card.Meta>
                                </Card.Content>
                                </Card>
                            )}
                            </Card.Group>

                                             </Grid.Column> </Grid.Row>

                    </React.Fragment>}
                <Divider section/>
            </Grid>
}
    render() {
        const data = this.props.dashboardData;
        return (<div style={{width: '90%', margin: 'auto'}}>
            {!this.state.isSubscribed && <PushNotificationWindow />}

            {  this.state.userRole === "clerk" && <React.Fragment>
                                <Message  style={{margin:"auto", marginTop:"10px",maxWidth:"500px",}} textAlign="center" warning>
                <Message.Header style={{textAlign:"center"}}>Please keep your availability info up to date</Message.Header>
                <hr/>
                <div style={{textAlign:"center"}}>                {!this.state.updatingAvailability && <Button disabled={this.state.isLoadingAvailability} loading={this.state.isLoadingAvailability} onClick={()=>{this.openAvailability()}} style={{margin:"auto"}} color="red" >Update Weekly Availability Info</Button>}  
                {!this.state.showLeave &&<Button secondary onClick={() => { this.setState( prevState => ({ showLeave: !prevState.showLeave }), () => { const el = document.getElementById("avail"); if (el) { el.scrollIntoView({ behavior: "smooth" }); } } ); }} > Mark Leave/Availability </Button>}</div>
            </Message>
                {this.state.updatingAvailability && <WeeklyAvailability 
                clerkData={this.state.profileData}
                callbackFn={() => {this.setState({updatingAvailability:false}) }}  />}
                        {this.state.showLeave && <div id="avail"><AvailLeave clerkId={this.state.profile_id}/></div>}
                </React.Fragment>}

            {/* {!(this.props.userRole === "agent") && <Segment textAlign="center">
                <LatestNews userRole={this.props.userRole} userId={this.state.userId} live={true} />
            </Segment>
            } */}
            <Grid style={{marginTop:"3rem"}}>
                <Grid.Row>
                    <Button.Group>
                             {this.props.userRole === "admin" && <Popup  on='click' wide="very"
                        trigger={
                            <Button icon={"time"} content="Chase Inventories" loading={this.state.isWaiting} />
                        }
                        content={<div style={{height:"350px"}}><Message>"Open All" may not work on your browser. in which case use the individual buttons</Message><Button compact basic color="blue" onClick={()=>{this.chaseReports()}} content="Get Chasing Data" loading={this.state.isWaiting} /> 
                                                    <hr/>
                    {this.state.UrlsToOpen && <div >
                        <Button disabled={this.state.UrlsToOpen.length == 0} onClick={()=>{this.openEmailWindows(true)}}>Open All O365</Button>
                            <Button disabled={this.state.UrlsToOpen.length == 0} onClick={()=>{this.openEmailWindows(false)}}>Open All Desktop</Button>
                            <hr/>            
                                <div
                                    style={{
                                        maxHeight: 150,
                                        overflowX: 'auto',
                                        overflowY: 'auto',
                                        paddingRight: '0.5rem',
                                    }}
                                    >
                                    {this.state.UrlsToOpen.map((urlToOpen, index) => (
                                        <div key={index} style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'0.3rem'}}>
                                        <span style={{flex:1,textAlign:'left'}}>{urlToOpen.name}</span>
                                        <div style={{display:'flex',gap:'0.25rem'}}>
                                            <Button compact basic size="mini" onClick={()=>window.open(urlToOpen.o365)}>Office 365</Button>
                                            <Button compact basic size="mini" onClick={()=>window.open(urlToOpen.desktop)}>Desktop</Button>
                                        </div>
                                        </div>

                                    ))}
                                    </div>
                        </div>}</div>}>
                            </Popup>}
                             {this.props.userRole === "admin" && <Popup  on='click' wide="very"
                        trigger={
                            <Button icon={"time"} content="Chase PVs" loading={this.state.isWaiting} />
                        }
                        content={<div><Button compact basic color="blue" onClick={()=>{this.chasePVReports()}} content="Use Desktop Email" loading={this.state.isWaiting} /> <Button compact basic color="blue" onClick={()=>{this.chasePVReports(true)}} content="Use Office 365" loading={this.state.isWaiting} /></div>}>
                            </Popup>}
                     {this.state.userRole !== "clerk" &&
                    <Button primary icon labelPosition='right'
                    onClick={(e) => {
                        this.props.history.push('inspection/create')
                    }}>Add New Inspection <Icon name='plus'/>
                    </Button>}
                    </Button.Group>
                    
                    
                    <div style={{position: 'absolute', right: '0'}}>
                                            
                        <Popup
                            trigger={<Button icon='filter' labelPosition='right' content='Date'/>}
                            content={<div>
                                <div><Header content="Filter By Date"/><Form><span><b>From: </b><DayPickerInput
                                    placeholder="From"
                                    dayPickerProps={{
                                        todayButton: 'Today',
                                        firstDayOfWeek : 1,
                                    }}
                                    format="DD-MM-YYYY"
                                    value={moment().format("DD-MM-YYYY")}
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    onDayChange={day => {day ? this.setState({fromDate: day,toDate:day}): this.setState({fromDate:undefined})}}/></span>
                                    <span><b>To: </b><DayPickerInput
                                    placeholder="To"
                                    format="DD-MM-YYYY"
                                    formatDate={formatDate}
                                    value={this.state.toDate}
                                    parseDate={parseDate}
                                    dayPickerProps={{
                                        disabledDays: {before: this.state.fromDate},
                                        todayButton: 'Today',
                                        firstDayOfWeek: 1,
                                }} onDayChange={day => {day ?this.setState({toDate: day}): this.setState({endDate:undefined}) }}/></span></Form></div>
                                <br/><Button content="Get Statistics" primary style={{marginLeft:'65%'}}
                                             onClick={() => this.handleFilterSelection()}/></div>}
                            on='click'
                            position="bottom left"
                            flowing
                            wide
                            hideOnScroll
                        />
                    </div>
                    <Divider></Divider>
                    </Grid.Row>
                    <Grid.Row>
                    {this.props.dashboardData ? <LastInspectionsListing data={this.props.dashboardData} renderStatObject={this.renderStatObject} userRole={this.props.userRole} />:<Loader contain={true} customText={"Loading Inspection Statistics "} />}
                </Grid.Row>
            </Grid>
            {/* {!(this.props.userRole === "agent") && <Grid style={{marginTop:"3rem"}}>
                <Header size="large" textAlign="left">
                    <div className="content">PROVISIONAL OFFERS</div>
                    <Popup  wide="very"
                        trigger={<div style={{ display: "inline" }}><Icon name="question circle" color="blue"></Icon></div>}>
                        <h2><strong>Inspections you may be interested in </strong><Icon circular name="eye" size="small"></Icon></h2>
                        <p>Bookings may choose to suggest an inspection to several clerks at the same time, contact bookings if any of the offers interest you.</p>
                        <p>Offers will disappear once a clerk has been confirmed</p>
                        <p>Please bear in mind possible scheduling conflicts before contacting bookings</p>
                        <p><strong>Note that any inspections listed will NOT yet be allocated to you.</strong></p>
                        
                    </Popup>
                </Header>
                <Grid.Row>
                    <ProvisionalOfferListing userRole={this.props.userRole} startDate={this.state.fromDate} endDate={this.state.toDate}/>
                </Grid.Row>
            </Grid>
            } */}
            {/* {!(this.props.userRole === 'agent') && <React.Fragment>
                <Youtube video="https://www.youtube.com/embed/videoseries?list=PLh6fzJH0Mi_byNC_IFABoMlt3KzxzMcwc"/>
                </React.Fragment>
            }
                        {(this.props.userRole === 'agent') && <React.Fragment>
                <Youtube video="https://www.youtube.com/embed/1DLbyPRKHC0"/>
                </React.Fragment>
            }
            {this.props.userRole === 'admin' && (this.state.showClerkDashboard ? <Grid>
                <Header size="large" content="CLERK DASHBOARD" textAlign="left"/>
                <Grid.Row>
                    <ClerkDashBoard startDate={this.state.fromDate} endDate={this.state.toDate}/>
                </Grid.Row>
            </Grid> : <div style={{textAlign:"center", marginBottom:"40px"}}><Segment> <Segment secondary><Header as="h1" content="Clerk Dashboard"/><Button primary onClick={() => { this.setState({ showClerkDashboard: true })}}>Show Clerk Dashboard</Button></Segment></Segment></div>
              )  } */}
            {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading} />} 
        </div>
        )
    }
}

export default FilterAttributes(DashboardStatistics(withRouter(Dashboard)));


// WEBPACK FOOTER //
// ./src/views/dashboard/index.js